(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import { Field } from "../forms";
var useStyles = makeStyles(function (theme) {
  return {
    root: function root(props) {
      return {
        marginRight: -14,
        // To offset InputField padding
        '& .MuiSvgIcon-root': {
          color: props.error ? theme.palette.error.main : theme.palette.text.secondary
        }
      };
    }
  };
});
import { TextField } from "./";

var DateField = function DateField(props) {
  var _props$id = props.id,
      id = _props$id === void 0 ? uuid() : _props$id,
      value = props.value,
      label = props.label,
      onChange = props.onChange,
      onBlur = props.onBlur,
      format = props.format,
      disablePast = props.disablePast,
      disableFuture = props.disableFuture,
      minDate = props.minDate,
      maxDate = props.maxDate,
      disableToolbar = props.disableToolbar,
      error = props.error,
      helpText = props.helpText,
      KeyboardDatePickerProps = props.KeyboardDatePickerProps,
      fullWidth = props.fullWidth;
  var classes = useStyles(props);
  return React.createElement(Field, {
    helpText: helpText
  }, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, React.createElement(KeyboardDatePicker, _extends({
    disableToolbar: disableToolbar,
    variant: "inline",
    format: format,
    disablePast: disablePast,
    disableFuture: disableFuture,
    minDate: minDate,
    maxDate: maxDate,
    id: id,
    label: label,
    value: value || null,
    onChange: onChange,
    onBlur: onBlur,
    autoOk: true,
    KeyboardButtonProps: {
      'aria-label': "Choose ".concat(label)
    },
    InputAdornmentProps: {
      className: classes.root
    },
    TextFieldComponent: TextField,
    error: error
  }, KeyboardDatePickerProps || {}, {
    fullWidth: fullWidth
  }))));
};

__signature__(DateField, "useStyles{classes}", function () {
  return [useStyles];
});

DateField.propTypes = {
  disableToolbar: PropTypes.bool,
  error: PropTypes.bool,
  helpText: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  KeyboardDatePickerProps: PropTypes.object
};
DateField.defaultProps = {
  format: 'dd.MM.yyyy',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  disableToolbar: true,
  error: false,
  fullWidth: false
};
var _default = DateField;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/home/vsts/work/1/s/src/components/inputs/DateField.js");
  reactHotLoader.register(DateField, "DateField", "/home/vsts/work/1/s/src/components/inputs/DateField.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/DateField.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();